import PartnerLogos from "components/partner-logos/partner-logos";
import IntroSlideTextTransitionSlider from "./intro-slide-text-transition";

interface TitleProp {
  Title?: string;
  id: number;
}

interface ImageProp {
  id: number;
  attributes: {
    alternativeText?: string;
    url?: string;
    data: {
      attributes: {
        url: string,
      },
    },
  };
}

interface IntroSlideTextProp {
  data: {
    TextBefore?: string,
    TextAfter?: string,
    LogoScale?: number,
    Logos?: {
      data: ImageProp[],
    },
    Text?: TitleProp[],
  };
}

const IntroSlideText: React.FC<IntroSlideTextProp> = ({ data }) => {
  const logoScale = data?.LogoScale ?? 100;

  return (
    <div className="intro-slide-text">
      <div className="container container--small">
        <div className="intro-slide-text__inner">
          <h1 className="intro-slide-text__head">
            <span className="intro-slide-text__title">{data.TextBefore}</span>

            {data.Text && <IntroSlideTextTransitionSlider data={data.Text} />}

            <span style={{ display: "block" }}>
              <span>{data.TextAfter}</span>
            </span>
          </h1>

          {data.Logos?.data && (
            <PartnerLogos logos={data.Logos.data} logoScale={logoScale} />
          )}
        </div>
      </div>
    </div>
  );
};

export default IntroSlideText;
